<template>
  <!-- 展览详情 -->
  <div class="page-exbition-detail">
    <div class="pic-box1">
      <img v-lazy="detail.mainPic" alt="" />
    </div>
    <div class="g-banner">
      <div class="exhibit">
        <div class="flex-box">
          <h1 class="name">{{ detail.name }}</h1>
          <div class="right-box">
            <p class="address" v-if="detail.address"><img class="add-img" src="../../assets/images/icon_place@2x.png" alt="">{{ detail.address }}</p>
            <p class="time">
              <img src="../../assets/images/icon_date@2x.png" alt="">
              {{ detail.beginTime && detail.endTime? $common.formatDateString(detail.beginTime, 'yyyy年MM月dd日') + '-' +$common.formatDateString(detail.endTime, 'yyyy年MM月dd日'): '常设展览' }}
            </p>
          </div>
        </div>
      </div>

      <cmpTab ref="cmpTab" :tabs="tabList" :activeVal="activeVal" @eventTabClick="eventTabClick"></cmpTab>
    </div>

    <div class="g-content-wrap">
      <!-- <div class="des-box" v-if="activeVal == 1">
        <p v-html="detail.des"></p>
      </div> -->
      <div class="g-detail-html" v-if="activeVal == 1">
        <p v-html="detail.des"></p>
      </div>

      <div v-if="activeVal == 2">
        <div class="list masonry-container g-pad-bottom-2" v-masonry transition-duration="0" item-selector=".item" :gutter="gutter">
          <div v-masonry-tile class="item" :class="{'min': gutter<25}" v-for="(item, index) in wwData" :key="index" @click="goDetailCollect(item)">
            <div class="pic-box2">
              <img :src="item.collectImages[0].attPath" :onerror="$store.state.app.defaultImg">
            </div>
            <div class="info">
              <h2 class="ell">{{item.collectName}}</h2>
              <p class="ell">{{item.collectYear}}</p>
            </div>
          </div>

          <!-- 无数据 -->
          <div class="g-no-data" v-if="wwData.length === 0">
            <div class="no-data-bg"></div>
            <p class="txt text-center">暂无数据</p>
          </div>
        </div>
      </div>

      <div class="right" v-if="activeVal == 3">
        <div class="list">
          <div class="video-list g-card-list" v-if="hotVideo && hotVideo.length > 0">
            <div class="item g-card-1" style="background: none" v-for="(item, index) in hotVideo" :key="index">
              <div class="pic-box">
                <img v-lazy="item.pic" alt="" />
                <div class="icon-play" @click="playVideo(item)"></div>
              </div>
              <div class="info1">
                <h2>{{ item.name }}</h2>
                <p class="time">{{ item.createrTime | dateFormat('yyyy年MM月dd日') }}</p>
              </div>
            </div>
          </div>

          <!-- 无数据 -->
          <div class="g-no-data" v-if="hotVideo.length === 0">
            <div class="no-data-bg"></div>
            <p class="txt text-center">暂无数据</p>
          </div>
        </div>
      </div>
    </div>

    <el-dialog :title="title" :visible.sync="detialPlayVideo" @close="closePlay">
      <player1 :video-url="videoUrl" :videoId="videoId"></player1>
    </el-dialog>
  </div>
</template>

<script>
import Vue from 'vue'
import cmpTab from '@cmp/tab'
import player1 from '@cmp/video-player'
import { VueMasonryPlugin } from 'vue-masonry'
Vue.use(VueMasonryPlugin)
export default {
  name: 'ExhibitionDetail',
  components: { cmpTab, player1 },
  data() {
    return {
      detailId: this.$route.query.id,
      detail: {},
      wwData: [],
      gutter: 25,

      hotVideo: [],
      videoUrl: '',
      videoId: '',
      title: '',
      detialPlayVideo: false,
      activeVal: '1',
      tabList: [
        {
          name: '展览简介',
          val: '1'
        },
        {
          name: '相关展品',
          val: '2'
        },
        {
          name: '相关视频',
          val: '3'
        }
      ]
    }
  },
  methods: {
    getDetailData() {
      this.$http
        .get('../singleMuseum/applet/exhibition/detail', {
          id: this.detailId
        })
        .then((res) => {
          if (res.success) {
            this.detail = res.result.detail
            this.wwData = res.result.bsCollectrecords
            this.hotVideo = res.result.bsAudioVideorecords

            if (this.wwData.length) {
              this.wwData.map((item) => {
                if (item.collectImages && item.collectImages.length > 0) {
                } else {
                  item.collectImages = []
                  item.collectImages.push({
                    attPath: require('@assets/images/error.png')
                  })
                }
              })
            }
          } else {
            this.$message.error(res.message)
          }
        })
    },
    goDetailCollect(item) {
      this.$router.push({
        path: '/collect/detail',
        query: { id: item.collectId }
      })
    },
    playVideo(item) {
      console.log(item)
      if (item.url) {
        this.detialPlayVideo = true
        this.videoId = item.id
        this.videoUrl = item.url
        this.title = item.name
      }
    },
    closePlay() {
      this.videoUrl = ''
      this.videoId = ''
      this.title = ''
      this.detialPlayVideo = false
    },
    eventTabClick(val) {
      this.activeVal = val
    },
    setBread() {
      // 动态修改面包屑
      this.pageType = this.$route.query.pageType || '0' // 0 常设展览  1 临时展览
      switch (this.pageType) {
        case '0':
          this.$store.dispatch('changeBread', [
            {
              text: '首页',
              href: '/home'
            },
            {
              text: '常设展览',
              href: '/exhibition'
            },
            {
              text: '详情',
              disabled: true
            }
          ])
          break
        case '1':
          this.$store.dispatch('changeBread', [
            {
              text: '首页',
              href: '/home'
            },
            {
              text: '临时展览',
              href: '/exhibition?type=1'
            },
            {
              text: '详情',
              disabled: true
            }
          ])
          break
      }

      this.$store.dispatch('changeBreadStyleType', '2')
    }
  },
  created() {
    this.setBread()
    this.getDetailData()
  },
  beforeRouteLeave(to, from, next) {
    let name = to.name
    if (['collectDetail'].includes(name)) {
      this.$store.dispatch('addCachedView', this.$route)
    } else {
      this.$store.dispatch('delCachedView', this.$route)
    }
    next()
  },

  // activated() {
  //   this.setBread()
  //   this.getDetailData()
  // },
  // beforeDestroy() {
  //   this.$store.dispatch('changeBreadStyleType', '')
  // },
  // deactivated() {
  //   this.$store.dispatch('changeBreadStyleType', '')
  // }
}
</script>

<style lang="scss" scoped>
.page-exbition-detail {
  .pic-box1 {
    padding-top: 30px;
    width: 100%;
    height: 100%;
    background: #f6f6f6;
    text-align: center;
    img {
      width: 1600px;
      height: 896px;
      object-fit: contain;
    }
  }

  .g-banner {
    padding-top: 48px;
    background: #f6f6f6;
    /deep/.cmp-tab-wrap {
      padding: 20px 0;
      .item {
        font-size: 24px;
        font-weight: 400;
        color: #000000;
        &.active {
          border-bottom: solid 4px rgba($color: #ae8148, $alpha: 0.8);
        }
      }
    }
  }

  .exhibit {
    width: 1600px;
    margin: 0 auto;

    .flex-box {
      justify-content: space-between;
      align-items: flex-start;
      .name {
        font-size: 32px;
        font-weight: 400;
        color: #000000;
      }

      .right-box {
        img {
          width: 24px;
          height: 24px;
          margin-right: 16px;
          &.add-img {
            width: 23px;
            height: 25px;
          }
        }
        p {
          font-size: 16px;
          font-weight: 400;
          color: #010101;
        }
      }
    }
    .address {
      margin-bottom: 33px;
    }
  }

  .g-content-wrap {
    margin-top: 72px;
    .pic-box {
      height: 288px;
    }

    .masonry-container {
      .g-card-list {
        display: initial;
      }
      .item {
        position: relative;
        margin-bottom: 35px;
        width: 375px;
        cursor: pointer;
        &.min {
          width: 360px;
        }
        .pic-box2 {
          position: relative;
          text-align: center;
          img {
            // max-width: 100%;
            // object-fit: cover;
            width: 100%;
            min-height: 200px;
          }
        }
        .info {
          padding: 28px 40px;
          background: rgba($color: #e1d9c8, $alpha: 0.4);
          font-size: 18px;
          // color: #fff;
          h2 {
            font-size: 24px;
            margin-bottom: 15px;
          }
        }
      }
    }
  }
  .des-box {
    width: 1053px;
    p {
      font-size: 16px;
      font-weight: 400;
      color: rgba($color: #000000, $alpha: 0.9);
      line-height: 32px;
    }
    /deep/img {
      width: 100%;
    }
  }

  .item {
    .info1 {
      border: 1px solid rgba(#121100, 0.2);
      border-top: none;
      padding: 23px 27px 24px 40px;
      h2 {
        font-size: 22px;
        font-weight: 400;
        color: #000000;
      }
      .time {
        margin-top: 12px;
        font-size: 16px;
        font-weight: 400;
        color: #000000;
      }

      .intro {
        font-size: 16px;
        font-weight: 400;
        color: rgba(#000000, 0.7);
      }
    }
  }
}
</style>
